import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface SourcePayoutStatusProps {
  payoutId: string | null;
  payoutStatus: string | null;
  paidAt: Date | string | null;
}

function formatStatus(status: string) {
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function SourcePayoutStatus({
  payoutId,
  payoutStatus,
  paidAt,
}: SourcePayoutStatusProps) {
  if (!payoutId) {
    return (
      <Badge variant="outline" className="whitespace-nowrap text-slate-500">
        Not in payout
      </Badge>
    );
  }

  if (paidAt) {
    return (
      <div className="space-y-1">
        <Badge className="bg-green-100 text-green-700 hover:bg-green-100">
          Paid
        </Badge>
        <div className="whitespace-nowrap text-xs text-slate-500">
          {format(new Date(paidAt), "MMM d, yyyy")}
        </div>
      </div>
    );
  }

  const status = payoutStatus ?? "processing";
  return (
    <Badge
      variant="outline"
      className={cn(
        "whitespace-nowrap",
        (status === "processing" || status === "transferred") &&
          "border-blue-200 bg-blue-50 text-blue-700",
        status === "payout_pending" &&
          "border-amber-200 bg-amber-50 text-amber-700",
        status === "failed" && "border-red-200 bg-red-50 text-red-700",
        (status === "canceled" || status === "reversed") &&
          "border-slate-300 bg-slate-100 text-slate-600",
      )}
    >
      {formatStatus(status)}
    </Badge>
  );
}
